var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import Vue from "vue";
import store from "../store";
import { cloneDeep } from 'lodash';
import { Component } from "vue-property-decorator";
import MainMenu from "../components/MainMenu.vue";
import ModuleTabContainer from "../components/ModuleTabContainer.vue";
import Main from './Main.vue';
import { CachePocily } from "../common/Cache";
import { ECache } from '../enum/ECache';
import { mapActions, mapGetters } from "vuex";
import CACHE_KEY from "../constant/cacheKey";
import GlobalVue from "../globalVue";
import Infor from "./account/Infor.vue";
import Password from "./account/Dialog.vue";
import MyService from "./service/MyService.vue";
import User from "./user/List.vue";
import LicenseList from "./licenseManage/LicenseList.vue";
import RootType from "../store/mutation-types";
import LoginService from "../api/LoginService";
import { ECommandType } from "../enum/ECommandType";
import MessageDialog from "@/components/login/MessageDialog.vue";
import AuthMixin from "../common/components/AuthMixin";
import MyWallet from "./myWallet/MyWallet.vue";
import HomeService from "../api/HomeService";
import AccountService from "../api/AccountService";
import NoticeAfterLogin from "../components/login/NoticeAfterLogin";
import { EServiceStatus } from "../enum/EStatus";
import GoodList from "./good/List.vue";
import { toDetail } from "../helper/util";
import inviteCustomer from "./account/InviteCustomer.vue";
import DialogBindWechat from '@/components/DialogBindWechat.vue';
import { Badge } from 'element-ui';
import 'element-ui/lib/theme-chalk/badge.css';
import AIAssistant from '../components/ai-assistant/AIAssistant.vue';
import RobotService from "../api/RobotService";
var serviceStatus = EServiceStatus;
var WsMesNoticeType = {
    '权限变更': 200,
    '入库单签字状态': 210,
    '退货单签字状态': 211,
    '对账单签字状态': 212,
    '发票开票成功': 230,
};
var Home = (function (_super) {
    __extends(Home, _super);
    function Home() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.cache = CachePocily.getInstance(ECache.LocCache);
        _this.loginForm = {};
        _this.pageAuth = null;
        _this.isCollapse = false;
        _this.initFlag = true;
        _this.websock = null;
        _this.version = "";
        _this.versionExpireDate = "";
        _this.downloadAmount = "";
        _this.showAIAssistant = false;
        _this.aiRobotInfo = null;
        _this.topList = [];
        _this.topListDefault = [];
        _this.topRightList = [];
        _this.topRightListDefault = [];
        return _this;
    }
    Home.prototype.created = function () {
        this.initWebSocket();
        try {
            var APP_VERSION_1 = localStorage.getItem(CACHE_KEY.APP_VERSION) || '';
            this.homeService = HomeService.getInstance();
            this.homeService.getUpdateInfo({ type: 3 }).then(function (res) {
                var DATA = res.data.data;
                var NEW_VERSION = DATA.app_version;
                if (APP_VERSION_1 !== NEW_VERSION) {
                    localStorage.setItem(CACHE_KEY.APP_VERSION, NEW_VERSION);
                    var url = "http://" + location.host + "/?version=" + (NEW_VERSION + location.hash);
                    location.replace(url);
                }
            });
        }
        catch (error) {
            console.log(error);
        }
    };
    Home.prototype.mounted = function () {
        return __awaiter(this, void 0, void 0, function () {
            var infor, currTime, overtime;
            var _this = this;
            return __generator(this, function (_a) {
                window.addEventListener("storage", function (e) {
                    !e.newValue && _this.$router.push({ path: '/' });
                    e.newValue && document.getElementById('login-page') && !window.location.pathname.includes('home') && window.location.reload();
                });
                this.loginService = LoginService.getInstance();
                this.accountService = AccountService.getInstance();
                this.robotService = RobotService.getInstance();
                infor = this.cache.getData(CACHE_KEY.LOGIN);
                if (infor && infor.ctime) {
                    currTime = new Date().getTime();
                    overtime = 7 * 24 * 60 * 60 * 1000;
                    if (currTime - infor.ctime > overtime) {
                        this.cache.remove(CACHE_KEY.LOGIN);
                        this.$store.commit(RootType.UPDATE_LOGINMODEL, null);
                        if (this.timer) {
                            clearInterval(this.timer);
                        }
                        return [2];
                    }
                    else {
                        if (infor.userInfo) {
                            this.loginForm = JSON.parse(infor.userInfo);
                            this.delayToken();
                        }
                    }
                }
                ;
                this.checkAIAssistantAvailable();
                this.showNoticeDialog();
                this.getServiceWarning();
                this.getVersion();
                this.getSummaryInfo();
                this.getTopList();
                this.getTopRightList();
                return [2];
            });
        });
    };
    Home.prototype.getTopList = function () {
        var _this = this;
        this.loginService.getTopList().then(function (res) {
            if (res.data.data.length) {
                _this.topList = res.data.data;
            }
            else {
                _this.topList = _this.topListDefault;
            }
            console.log('------topList', _this.topList);
        }).catch(function () {
            _this.topList = _this.topListDefault;
        });
    };
    Home.prototype.getTopRightList = function () {
        var _this = this;
        this.loginService.getTopRightList().then(function (res) {
            if (res.data.data.length) {
                _this.topRightList = res.data.data;
            }
            else {
                _this.topRightList = _this.topRightListDefault;
            }
            console.log('------topRightList', _this.topRightList);
        }).catch(function () {
            _this.topRightList = _this.topRightListDefault;
        });
    };
    Home.prototype.clickBannerImg = function (item) {
        var landing_type = item.landing_type || 0;
        if (2 == landing_type) {
            this.$router.push('/managementLandingCustom?id=' + item.id);
        }
        else if (3 == landing_type) {
            console.log(333, item);
            window.open(item.landing_url || '');
        }
    };
    Home.prototype.getVersion = function () {
        var _this = this;
        this.accountService.getAccountInfo().then(function (res) {
            var data = res.data.data || {};
            var userInfo = cloneDeep(_this.user);
            _this.version = data.supplier_version;
            _this.versionExpireDate = data.supplier_version_expire_date;
            userInfo.is_bind_official_account = data.is_bind_official_account;
            _this.cache.save(CACHE_KEY.LOGIN, {
                ctime: new Date().getTime(),
                userInfo: JSON.stringify(userInfo)
            });
            _this.$store.commit(RootType.UPDATE_LOGINMODEL, Object.assign({}, userInfo));
            console.log('------infor.userInfo.is_bind_official_account', data.is_bind_official_account);
            var LastIsBindOfficialAccountKey = CACHE_KEY.IS_BIND_OFFICIAL_ACCOUNT + '_' + data.account_id;
            var lastDate = localStorage.getItem(LastIsBindOfficialAccountKey);
            var currentDate = new Date().toDateString();
            console.log('------LastIsBindOfficialAccountKey', LastIsBindOfficialAccountKey);
            console.log('------lastDate', lastDate);
            console.log('------currentDate', currentDate);
            if (lastDate === currentDate) {
                return true;
            }
            localStorage.setItem(LastIsBindOfficialAccountKey, currentDate);
            if (data && data.is_bind_official_account != 1) {
                setTimeout(function () {
                    _this.openBindWechatDialog();
                }, 2000);
            }
        }, function (error) {
            _this.$message.error(error.message);
        });
    };
    Home.prototype.toMyWallet = function () {
        this.updateHomeShow(false);
        GlobalVue.$emit("addTab", {
            component: MyWallet,
            title: "我的钱包",
            name: "wallet",
            showExist: true,
        });
    };
    Home.prototype.delayToken = function () {
        var _this = this;
        this.delayTokenAjax();
        var sTimer = 60 * 60 * 1000;
        this.timer = setInterval(function () {
            _this.delayTokenAjax();
        }, sTimer);
    };
    Home.prototype.delayTokenAjax = function () {
        var _this = this;
        var infor_again = this.cache.getData(CACHE_KEY.LOGIN);
        var userInfo = '';
        if (infor_again && infor_again.userInfo) {
            var data = JSON.parse(infor_again.userInfo);
            if (data && data.token) {
                userInfo = data;
            }
        }
        ;
        if (!userInfo) {
            if (this.timer) {
                clearInterval(this.timer);
            }
            return;
        }
        return this.loginService.delayToken().then(function (res) {
            if (res.data.success) {
                _this.cache.save(CACHE_KEY.LOGIN, {
                    ctime: new Date().getTime(),
                    userInfo: JSON.stringify(userInfo)
                });
            }
            else {
                _this.$message.error(res.data.msg || '登陆状态更新失败');
                if (_this.timer) {
                    clearInterval(_this.timer);
                }
            }
        }, function (error) {
            _this.$message.error(error.message);
            if (_this.timer) {
                clearInterval(_this.timer);
            }
        });
    };
    Home.prototype.destroyed = function () {
        this.initFlag = false;
        this.websock.close();
    };
    Home.prototype.initWebSocket = function () {
        if (!this.initFlag)
            return;
        var wsurl = '';
        if (window.location.host.indexOf('3003') !== -1) {
            wsurl = "wss://ws.acewill.cn/ws?token=" + this.user.token + "&type=pc";
        }
        else if (window.location.host.indexOf('cn') === -1) {
            wsurl = "ws://58.87.93.32:81/ws?token=" + this.user.token + "&type=pc";
        }
        else {
            wsurl = "wss://ws.acewill.cn/ws?token=" + this.user.token + "&type=pc";
        }
        this.websock = new WebSocket(wsurl);
        this.websock.onmessage = this.websocketonmessage;
        this.websock.onopen = this.websocketonopen;
        this.websock.onerror = this.websocketonerror;
        this.websock.onclose = this.websocketclose;
    };
    Home.prototype.websocketonopen = function () {
        console.log('websocketonopen');
    };
    Home.prototype.websocketonerror = function () {
        var _this = this;
        console.log('websocketonerror');
        setTimeout(function () {
            _this.websock.close();
        }, 60000);
    };
    Home.prototype.websocketonmessage = function (data) {
        var _this = this;
        var msgData = JSON.parse(data.data);
        console.log('------websocketonmessage', msgData);
        if (msgData.notice_type == WsMesNoticeType['入库单签字状态']) {
            GlobalVue.$emit('po_sign:ok');
            return;
        }
        else if (msgData.notice_type == WsMesNoticeType['退货单签字状态']) {
            GlobalVue.$emit('ro_sign:ok');
            return;
        }
        else if (msgData.notice_type == WsMesNoticeType['对账单签字状态']) {
            GlobalVue.$emit('so_sign:ok');
            return;
        }
        else if (msgData.notice_type == WsMesNoticeType['发票开票成功']) {
            GlobalVue.$emit('document:ok');
            return;
        }
        this.$alert(msgData.msg, '提示', {
            confirmButtonText: WsMesNoticeType['权限变更'] == msgData.notice_type ? '确定' : '查看',
            showClose: msgData.notice_type != WsMesNoticeType['权限变更'],
            callback: function (action) {
                if (action == 'confirm') {
                    if (msgData.notice_type == WsMesNoticeType['权限变更']) {
                        _this.refreshUsrAuth();
                    }
                    else {
                        _this.toMsgPage();
                    }
                }
            }
        });
    };
    Home.prototype.websocketsend = function (Data) {
        console.log('websocketsend');
    };
    Home.prototype.websocketclose = function (e) {
        var _this = this;
        console.log('断开连接', e);
        setTimeout(function () {
            _this.initWebSocket();
        }, 60000);
    };
    Home.prototype.openPage = function (menu) {
        var menuList = this.$refs.menu;
        menuList.openPage(menu);
    };
    Home.prototype.openBindWechatDialog = function () {
        var _this = this;
        var instance = this.$dialog(DialogBindWechat, {
            data: {
                user: this.user
            }
        }, {
            title: "开启微信实时通知",
            width: 700,
            height: 400,
            zIndex: 1002,
        }).instance;
        instance.$on('success', function (data) {
            _this.loginForm.is_bind_official_account = data.is_bind_official_account;
            _this.cache.save(CACHE_KEY.LOGIN, {
                ctime: new Date().getTime(),
                userInfo: JSON.stringify(_this.loginForm)
            });
            _this.$store.commit(RootType.UPDATE_LOGINMODEL, Object.assign({}, _this.loginForm));
        });
    };
    Home.prototype.openServiceDialog = function (data) {
        var _this = this;
        var instance = Vue.prototype.$dialog(MessageDialog, {
            data: {
                msg: data.msg,
                service_status: data.service_status
            }
        }, {
            title: "提示",
            width: 420,
            height: 250,
            zIndex: 100000
        }).instance;
        instance.$on('openService', function (service_status) {
            _this.updateHomeShow(false);
            GlobalVue.$emit("addTab", {
                component: MyService,
                title: "会员服务",
                name: "service",
                showExist: true,
                cprops: {
                    service_status: service_status
                }
            });
        });
        instance.$on('payService', function (service_status) {
            _this.updateHomeShow(false);
            GlobalVue.$emit("addTab", {
                component: MyService,
                title: "会员服务",
                name: "service",
                showExist: true,
                cprops: {
                    service_status: service_status
                }
            });
        });
    };
    Home.prototype.getServiceWarning = function () {
        var _this = this;
        this.loginService.getServiceWarning().then(function (res) {
            store.dispatch('updateServiceData', res.data.data);
            store.dispatch('updateServiceFlag', res.data.data.flag == 2 || false);
        }, function (error) {
            _this.$message.error(error.message);
        });
    };
    Home.prototype.itemClick = function (menuItem, isHome, pageAuth) {
        this.updateHomeShow(isHome);
        var html = document.getElementById("app").parentElement.parentElement, menu = document.getElementsByClassName('menu-content')[0];
        html.scrollTop = 0;
        if (isHome) {
            html.style.overflowY = "auto";
            menu.style.height = document.documentElement.clientHeight + 'px';
        }
        else {
            html.style.overflowY = "hidden";
            menu.style.height = document.documentElement.clientHeight - 85 + 'px';
        }
        if (isHome) {
            this.pageAuth = this.pageAuth || pageAuth && pageAuth.Auth;
        }
    };
    Home.prototype.tabClose = function () {
        if (!this.$refs.tab.getTabs().length) {
            this.updateHomeShow(true);
            this.$refs.menu.openPage({
                power_code: "500000",
                power_id: 1
            });
            this.$refs.menu.defaultActive = "MENU_1";
        }
    };
    Home.prototype.accountCommand = function (command) {
        switch (command) {
            case 1:
                this.updateHomeShow(false);
                GlobalVue.$emit("addTab", {
                    component: Infor,
                    title: "账号信息",
                    name: "account_" + command,
                    showExist: true
                });
                break;
            case 2:
                this.changePwd();
                break;
            case 3:
                this.updateHomeShow(false);
                GlobalVue.$emit("addTab", {
                    component: MyService,
                    title: "会员服务",
                    name: "service",
                    showExist: true
                });
                break;
            case 4:
                this.logout();
                break;
        }
    };
    Home.prototype.inviteBtn = function () {
        var instance = this.$dialog(inviteCustomer, {
            data: {}
        }, {
            title: "邀请客户",
            width: 750,
            height: 500
        }).instance;
        instance.$on('savePassword:ok', function () {
        });
    };
    Home.prototype.changePwd = function () {
        var _this = this;
        var instance = this.$dialog(Password, {
            data: {
                isChangePwd: true,
                phone: this.user.phone
            }
        }, {
            title: "修改密码",
            width: 600,
            height: 300
        }).instance;
        instance.$on('savePassword:ok', function () {
            _this.$message.success('修改成功！');
        });
    };
    Home.prototype.logout = function () {
        var _this = this;
        this.loginService.logout().then(function (res) {
            _this.cache.remove(CACHE_KEY.LOGIN);
            _this.$store.commit(RootType.UPDATE_LOGINMODEL, null);
            _this.$router.push({ path: '/' });
        }, function (error) {
            _this.$message.error(error.message);
        });
    };
    Home.prototype.settingsCommand = function (command) {
        this.updateHomeShow(false);
        switch (command) {
            case ECommandType.License:
                GlobalVue.$emit("addTab", {
                    component: LicenseList,
                    title: "证照管理",
                    name: "license_" + command,
                    showExist: true
                });
                break;
            case ECommandType.User:
                GlobalVue.$emit("addTab", {
                    component: User,
                    title: "用户管理",
                    name: "user_" + command,
                    showExist: true
                });
                break;
        }
    };
    Home.prototype.toMsgPage = function (isSupplierMessage) {
        var menu = {
            power_code: '1400000',
            power_id: 89,
            power_cn: '消息通知'
        };
        if (isSupplierMessage) {
            menu.defaultFormData = {
                msg_type: 4,
                status: 0,
            };
        }
        this.openPage(menu);
    };
    Home.prototype.toDownloadPage = function () {
        var menu = {
            power_code: '5008',
            power_id: 403,
            power_cn: '导出结果下载'
        };
        this.openPage(menu);
    };
    Home.prototype.refreshUsrAuth = function () {
        window.location.reload();
    };
    Home.prototype.getSummaryInfo = function () {
        var _this = this;
        this.homeService.getSummaryInfo().then(function (res) {
            console.log(res);
            _this.downloadAmount = res.data.data.download_amount;
        }).catch(function (err) {
            _this.$message.error(err.msg || err.message);
        });
    };
    Home.prototype.showNoticeDialog = function () {
        var _this = this;
        var tips = [];
        this.loginService.getNotice({}).then(function (res) {
            if (res.data.data.length == 0)
                return;
            tips = res.data.data;
            _this.openTipsDialog(tips);
        }).catch(function (err) {
            _this.$message.error(err.msg || err.message);
        });
    };
    Home.prototype.openTipsDialog = function (tips) {
        var _this = this;
        var instance = this.$dialog(NoticeAfterLogin, {
            data: {
                tips: tips
            }
        }, {
            title: "提示",
            width: 420,
            zIndex: 100000,
            closeBtn: true
        }).instance;
        instance.$on('openMyService', function (noticeData) {
            _this.updateHomeShow(false);
            GlobalVue.$emit("addTab", {
                component: MyService,
                title: "会员服务",
                name: "service",
                showExist: true,
                cprops: {
                    noticeData: noticeData
                },
                callback: function () {
                    console.log('打开了会员服务');
                }
            });
        });
        instance.$on('payMyService', function (noticeData) {
            _this.updateHomeShow(false);
            GlobalVue.$emit("addTab", {
                component: MyService,
                title: "会员服务",
                name: "service",
                showExist: true,
                cprops: {
                    statusFromNotice: serviceStatus.Opened,
                    noticeData: noticeData
                },
                callback: function () {
                    console.log('打开了会员服务');
                }
            });
        });
        instance.$on('logout', function () {
            _this.logout();
        });
        instance.$on('openAddGood', function () {
            _this.getAuth('8001').then(function (pageAuth) {
                _this.updateHomeShow(false);
                GlobalVue.$emit("addTab", {
                    component: GoodList,
                    title: "货品档案",
                    name: "addgood",
                    showExist: true,
                    callback: function () {
                        console.log('上传货品');
                    },
                    cprops: __assign({}, pageAuth.Response, { Root_PageAuth: pageAuth && pageAuth.Auth, root_PageAuth$$: pageAuth && pageAuth.Auth })
                });
            });
        });
        instance.$on('supplierMessage', function (notice) {
            if (notice.button_type === 1) {
                _this.toMsgPage(true);
            }
            else {
                _this.updateHomeShow(false);
                toDetail(notice.notice_params.type, notice.notice_params.order_id);
            }
        });
    };
    Home.prototype.checkAIAssistantAvailable = function () {
        var _this = this;
        try {
            this.robotService.getRobotInfo().then(function (res) {
                if (res.data.success && res.data.data.robot_code) {
                    _this.showAIAssistant = true;
                    _this.aiRobotInfo = res.data.data;
                }
                else {
                    _this.showAIAssistant = false;
                }
            }, function (err) {
                _this.$message.error(err.message || err.msg);
            }).catch(function (err) {
                _this.$message.error(err.message);
            });
        }
        catch (e) {
            this.showAIAssistant = false;
        }
    };
    Home = __decorate([
        Component({
            mixins: [AuthMixin],
            components: {
                "main-menu": MainMenu,
                'main-wrapper': Main,
                "module-tab-container": ModuleTabContainer,
                "el-badge": Badge,
                "ai-assistant": AIAssistant
            },
            methods: __assign({}, mapActions(["getAuth", "updateHomeShow"])),
            computed: __assign({}, mapGetters({
                user: 'user',
                homeShow: 'homeShow',
                serviceData: 'serviceData',
                openedCodeData: 'openedCodeData'
            }), { isExpiringSoon: function () {
                    if (!this.versionExpireDate) {
                        return false;
                    }
                    try {
                        var expireDate = new Date(this.versionExpireDate);
                        var today = new Date();
                        var diffTime = expireDate.getTime() - today.getTime();
                        var diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
                        return diffDays >= 0 && diffDays <= 15;
                    }
                    catch (e) {
                        return false;
                    }
                } })
        })
    ], Home);
    return Home;
}(Vue));
export default Home;
